"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataTable_1 = require("./components/DataTable/DataTable");
exports.DataTable = DataTable_1.default;
var TreeTable_1 = require("./components/TreeTable/TreeTable");
exports.TreeTable = TreeTable_1.default;
//# sourceMappingURL=main.js.map